module.exports = __webpack_public_path__ + "img/dl_ios.b5d71555.png";